export default __webpack_public_path__ + "assets/vital-brasil-component.2ff2b078.svg";